import api from '@/api';

const state = {
  token: null,
};

const getters = {
  isLoggedIn: state => state.token != null,
};

const actions = {
  init({ commit }) {
    if (localStorage.getItem('account/token')) {
      commit('token', localStorage.getItem('account/token'));
    }
  },

  async authorization({ commit }, payload) {
    const response = await api.post('Authorization/Authorization', { code: payload.code, state: payload.state });
    commit('token', response.data.token);
  },
};

const mutations = {
  token(state, payload) {
    state.token = payload;
    if (payload) {
      localStorage.setItem('account/token', payload);
    } else {
      localStorage.removeItem('account/token');
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
